import { ItemType } from '@wix/wix-vod-constants/api-types';
import { LIVE_VIDEO_STATUS } from '@wix/wix-vod-constants/common';
export const isScheduledLive = ({ itemType }) => itemType === ItemType.ItemScheduled;
export const isStreamingLive = ({ itemType }) => itemType === ItemType.ItemLive;
export const isPendingLiveStream = ({ liveVideoStatus }) => liveVideoStatus === LIVE_VIDEO_STATUS.PENDING;
export const isReadyLiveStream = ({ liveVideoStatus }) => liveVideoStatus === LIVE_VIDEO_STATUS.IN_PROGRESS;
//# sourceMappingURL=live.js.map